/* Storefront events, announced and not sent.
   The theme names the moments an analyst asks about (the quiz reaching its
   result, a batch report opened, a shelf arrow pressed, the contact and
   newsletter forms sent, a state chosen) and hands each one to Shopify's
   customer-events bus, where a custom pixel written in the admin decides
   where it goes: GA4, Meta, a spreadsheet, nowhere. The theme itself calls
   no third party. Each event also lands on window.dataLayer for a tag manager
   that may be added one day, and nothing here runs twice for one moment. */
(() => {
  const publish = (name, data) => {
    const payload = Object.assign({ path: location.pathname }, data || {});
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, payload);
      }
    } catch (e) { /* the bus is optional */ }
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, payload));
    } catch (e) { /* so is the layer */ }
    document.dispatchEvent(new CustomEvent('sa:event', { detail: { name, payload } }));
  };
  window.saPublish = publish;

  /* clicks: a shelf arrow, a batch report, the state check's answer */
  document.addEventListener('click', (e) => {
    const t = e.target.closest('a, button');
    if (!t) return;
    if (t.classList.contains('sa-shelf__arrow')) {
      const shelf = t.closest('.sa-shelf');
      const heading = shelf && shelf.querySelector('.sa-shelf__heading, .sa-shelf__format');
      publish('sa_carousel_interaction', {
        direction: t.classList.contains('sa-shelf__arrow--next') ? 'next' : 'prev',
        shelf: heading ? heading.textContent.trim() : '',
      });
      return;
    }
    if (t.matches('.coa-link, .sa-labhub__file, a[href$=".pdf"], a[href*="lab-results"]')) {
      publish('sa_lab_report_view', { href: t.getAttribute('href') || '', label: (t.textContent || '').trim().slice(0, 80) });
    }
  }, { passive: true });

  /* the state chosen in any "can you ship to my state" row */
  document.addEventListener('change', (e) => {
    const s = e.target;
    if (!s.matches || !s.matches('[data-sa-states-select]')) return;
    publish('sa_state_check', { state: s.value || '' });
  });

  /* forms sent: contact and newsletter, on submit rather than on success, since
     both leave the page; the pixel side can read the thank-you if it needs to */
  document.addEventListener('submit', (e) => {
    const f = e.target;
    if (!f || !f.matches) return;
    if (f.matches('.contact-form, form[action*="/contact"]') && !f.classList.contains('newsletter-form')) {
      const topic = f.querySelector('[name="contact[Topic]"]');
      publish('sa_form_submit', { form: 'contact', topic: topic ? topic.value : '' });
    } else if (f.matches('.newsletter-form')) {
      publish('sa_newsletter_subscribe', { form: f.id || 'newsletter' });
    }
  });

  /* the quiz: its result is a hidden section that is shown once; watch the
     attribute rather than the click, so a keyboard answer counts too */
  const quiz = () => {
    document.querySelectorAll('[data-sa-quiz-result]').forEach((r) => {
      if (r.dataset.saEventsBound) return;
      r.dataset.saEventsBound = '1';
      const mo = new MutationObserver(() => {
        if (r.hidden) return;
        const h = r.querySelector('[data-sa-quiz-result-heading]');
        publish('sa_quiz_complete', { result: h ? h.textContent.trim().slice(0, 80) : '' });
        mo.disconnect();
      });
      mo.observe(r, { attributes: true, attributeFilter: ['hidden'] });
    });
  };
  quiz();
  document.addEventListener('shopify:section:load', quiz);

  /* Product page, Brief 5: what the client measures after launch.
     - how far down a visitor gets: a block marked data-sa-step="3" (how to
       take it) or "5" (proof) announces itself once, when its top reaches the
       middle of the screen;
     - which button added to the cart: the buy box's own, the sticky bar or
       the guarantee card. The bar and the card press the buy box's button,
       and say first that it was them;
     - which plan was chosen (the bundle tile announces itself). */
  const product = () => {
    const meta = document.querySelector('product-info[data-product-id], [data-product-id]');
    return meta ? meta.getAttribute('data-product-id') : '';
  };
  const steps = () => {
    const marks = document.querySelectorAll('[data-sa-step]');
    if (!marks.length || !('IntersectionObserver' in window)) return;
    const seen = new Set();
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const step = entry.target.getAttribute('data-sa-step');
        io.unobserve(entry.target);
        if (seen.has(step)) return;
        seen.add(step);
        publish('sa_pdp_step_view', { step: step, product: product(), phone: window.matchMedia('(max-width: 749px)').matches });
      });
    }, { rootMargin: '0px 0px -50% 0px', threshold: 0 });
    marks.forEach((m) => io.observe(m));
  };
  steps();

  document.addEventListener('click', (e) => {
    const t = e.target.closest && e.target.closest('.product-form__submit');
    if (!t || !t.closest('product-info')) return;
    const source = window.saAtcSource || 'buybox';
    window.saAtcSource = '';
    if (t.disabled) return;
    const state = window.saBuyState || {};
    publish('sa_add_to_cart_click', {
      source: source,
      product: product(),
      qty: state.qty || 1,
      plan: state.plan || '',
      phone: window.matchMedia('(max-width: 749px)').matches
    });
  }, true);

  document.addEventListener('change', (e) => {
    const t = e.target;
    if (!t.matches || !t.matches('[data-sa-plan-input], [data-sa-freq]')) return;
    const row = t.closest('[data-sa-plan-row]');
    const label = t.getAttribute('data-label') || (row && (row.dataset.saPlanLabel || '')) || (t.value ? 'subscription' : 'one-time');
    publish('sa_plan_select', { plan: t.value ? label : 'one-time', product: product() });
  });
})();
